import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'react-bootstrap';

function HomeComponent() {
  const { loginWithRedirect } = useAuth0();
  return (
    <div>
      <h1>Home</h1>
      <Button onClick={loginWithRedirect}>Login</Button>
    </div>
  );
}

export const Home = HomeComponent;
